export const orderNumberConstants = {
    ORDER_NUMBER_REQUEST: 'ORDER_NUMBER_REQUEST',
    ORDER_NUMBER_SUCCESS: 'ORDER_NUMBER_SUCCESS',
    ORDER_NUMBER_FAILURE: 'ORDER_NUMBER_FAILURE',
};
